import { render } from "./PaymentItem.vue?vue&type=template&id=7955c3bd"
import script from "./PaymentItem.vue?vue&type=script&lang=js"
export * from "./PaymentItem.vue?vue&type=script&lang=js"

import "./PaymentItem.vue?vue&type=style&index=0&id=7955c3bd&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__